import React, { useEffect, useState } from "react";

import { useTranslation } from 'react-i18next';

import labelIcon from 'assets/icons/manual_label.svg'
import arrowViewAllIcon from 'assets/icons/arrow_viewall_manual.svg'
import arrowViewTopicIcon from 'assets/icons/arrow_topic_manual.svg'
import { useParams } from 'react-router-dom';

import axios from "axios";
import "./manual.scss"
import { Link } from "react-router-dom";

const listManualTopic = (props)=>{
    
    return (
            props.topics?props.topics.map((v)=>{
                        return (
                            <>
                            <div>topic</div>
                            </>
                        )
                    }):""

    )
       
    
}

const Manual = ()=>{
    const { t } = useTranslation();
    const [mainCategories,setMainCategories] = useState();
    const [manualTopicList,setManualTopicList] = useState();


useEffect(()=>{
    const main_categories = async ()=>{
        const categories = await axios.get("https://gis247.net/wp-json/content-api/manual/get-manual-main-categories-with-sub");
        
        
        console.log(categories.data);
        setMainCategories(categories.data);
    }
    main_categories()
},[])

    return (
        <>
    <div className="main-content-wrapper-body">
        <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
            <div className="main-content-wrapper-body-top-bar-left">
            <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
                <span>{t("User Manual")}</span>
            </h1>
            </div>

       
            
        </div>    

             <div className="manual_wrp">
                <div className="row manual_list_wrp">
         
                                    {
                                    mainCategories?mainCategories.map((vc,key)=>{

                                        let linkCategories =  vc.layout==="with_portal" ? `/app/admin/view-manual/portal/${vc.id}`: `/app/admin/view-manual/${vc.id}`
                                        return (

                    <div className="col-md-3 list_categories" key={key}>
                                            <h3><span><img src={labelIcon} alt="label_icon" className="label_icon"/></span>{vc.name}</h3>
                                            <ul>
                                            {vc.post?
                                            vc.post.slice(0,10).map((v,k)=>{
                                              

                                                const topicLink = v.post_sidebar_style==="link_to_topic" ? `/app/admin/view-manual/topic/${v.category}/${v.post_category_id}/${v.id}`: `/app/admin/view-manual/${v.category}/${v.post_category_id}/#${v.section_title}`
                                                return (

                                                    <Link to={topicLink}>
                    <li key={k}>
                                                <span class="topic_icon"><img src={arrowViewTopicIcon}/></span> 
                                                <span  class="topic_heading">{v.heading_en}</span>
                                                </li>

                                                    </Link>
                                                    
                                                )
                                        
                                            })
                                            :""}
                                            
                                            </ul>
                                            <Link to={linkCategories} className="view_all_link">View All <span><img src={arrowViewAllIcon} className="view_all_topic_icon"/></span></Link>
                        </div>


                                        )

                    }):"" 
                    }

                </div>
               

            </div>    
      </div>        
        </>
    )

}

export default Manual;